import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Close",
  "use": "Close-usage",
  "viewBox": "0 0 30 29",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 29\" id=\"Close\"><path fill-rule=\"evenodd\" d=\"M.938 4.548L5.11.375l9.91 9.91L25.452.375l4.173 4.173-10.432 9.91L29.625 24.89l-4.173 4.172-10.432-10.43-9.91 10.43L.937 24.89l9.91-10.432z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol